import { createContext } from 'react'

export type TableVariant = 'default' | 'simple'

export const TableVariantContext = createContext<TableVariant>('default')
